module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/15mill-inactive-6d19845cf1dd7204f60cd8f643579726.png";